exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NbEZOQN3W2sVYdpSriBzT{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:clip;width:100%;vertical-align:bottom}", ""]);

// exports
exports.locals = {
	"truncatedRecipientsContainer": "NbEZOQN3W2sVYdpSriBzT"
};